module.exports = __webpack_public_path__ + "img/mx_seguromultidispositivo.41ba46a6.svg";